import { MapTo } from "@adobe/aem-react-editable-components";
import { SimplifiedPrizes } from "@jti/loyalty";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
export const simplifiedPrizesEditConfig = {
    emptyLabel: "SimplifiedPrizes",
    isEmpty: (props) => !props.ctaLabel ||
        !props.errorMessage ||
        !props.pointsLabel ||
        !props.loadMoreButtonLabel ||
        !props.unitLabel ||
        !props.noOffersText,
    getProps: (props) => ({
        ctaLabel: props.ctaLabel,
        color: props.color,
        noOffersText: props.noOffersText,
        showNotAvailablePrizes: props.showNotAvailablePrizes,
        confirmationMessage: props.confirmationMessage,
        confirmationMessagePlural: props.confirmationMessagePlural,
        newOfferDays: props.newOfferDays,
        newLabel: props.newLabel,
        oneDayLabel: props.oneDayLabel,
        daysLabel: props.daysLabel,
        isTeaser: props.isTeaser,
        pagination: props.pagination,
        teaserData: props.teaserData,
        loadMoreButtonLabel: props.loadMoreButtonLabel,
        errorMessage: props.errorMessage,
        outOfStockLabel: props.outOfStockLabel,
        tierRestrictedLabel: props.tierRestrictedLabel,
        availablePointsLabel: props.availablePointsLabel,
        balanceAfterRedemptionLabel: props.balanceAfterRedemptionLabel,
        bottomText: props.bottomText,
        codeInfo: props.codeInfo,
        codeLabel: props.codeLabel,
        costLabel: props.costLabel,
        dialogTitle: props.dialogTitle,
        dialogTitleConfirmation: props.dialogTitleConfirmation,
        pointsLabel: props.pointsLabel,
        primaryCta: props.primaryCta,
        secondaryCta: props.secondaryCta,
        unitLabel: props.unitLabel,
        emailHint: props.emailHint,
        emailLabel: props.emailLabel,
        externalCodeButtonLabel: props.externalCodeButtonLabel,
    }),
};
export default MapTo("loyalty/components/simplifiedprizes")(withAemAuthoring(SimplifiedPrizes, simplifiedPrizesEditConfig));
